export default {
  state: {
    acceptNotification: {
      show: false,
      accept: false,
      isPackage: false,
      id: null,
      driverId: null,
      driverName: '',
      isSendAsSchedule: false,
      sendAsScheduleError: '',
      runsDeclined: false
    }
  },
  mutations: {
    showDispatchAcceptNotification (state, value) { state.acceptNotification = value },
    hideDispatchAcceptNotification (state) {
      state.acceptNotification = {
        show: false,
        accept: false,
        isPackage: false,
        id: null,
        driverId: null,
        driverName: '',
        isSendAsSchedule: false,
        sendAsScheduleError: '',
        runsDeclined: false
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/dispatch/dispatch-notification.js